module.exports = __webpack_public_path__ + "img/success@2x.3e4280d8.png";